import { wgRenderState } from "./wgRenderState.js";

class wgContext {
    constructor(gl, canvas) {
        this.gl_ = gl;
        this.canvas_ = canvas;
        this.glState_ = new wgRenderState();
    }

    isValid() {
        return this.gl_ !== undefined;
    }
    gl() {
        return this.gl_;
    }
    glState() {
        return this.glState_;
    }
    resetGlState() {
        this.glState_.reset();
    }
    getCanvas() {
        return this.canvas_;
    }
    getCanvasWidth() {
        return this.canvas_.width;
    }
    getCanvasHeight() {
        return this.canvas_.height;
    }
    // OpenGL context queries TODO
    getMaxNumberOfSamples() {
        return this.gl_.getParameter(this.gl_.MAX_SAMPLES);
    }
}

export { wgContext };
